import helpIcon from 'images/icons/svg/info.svg';
import React from 'react';
import styled, { css } from 'styled-components';

const HelpIcon: React.FunctionComponent<{
  content: JSX.Element | string;
  position?: 'top' | 'bottom' | 'left' | 'right' | 'mouse' | undefined;
}> = ({ content, position }) => {
  return (
    <TooltipContainer data-pr-position={position || 'right'}>
      <div className="tooltip-trigger" style={{ display: 'flex', alignItems: 'end' }}>
        <Image alt="Help" src={helpIcon} />
      </div>
      <div className="tooltip-content" data-tooltip={content}></div>
    </TooltipContainer>
  );
};

const TooltipContainer = styled.span`
  position: relative;
  cursor: pointer;

  & .tooltip-content::before {
    content: attr(data-tooltip);
    position: absolute;
    color: #fff;
    font-weight: normal;
    padding: 5px;
    border-radius: 4px;
    transition: opacity 0.3s;
    left: auto;
    right: auto;
    transform: translateX(-50%);

    ${(props) =>
      props['data-pr-position'] &&
      props['data-pr-position'].includes('top') &&
      css`
        bottom: 110%;
        top: auto;
      `}

    ${(props) =>
      props['data-pr-position'] &&
      props['data-pr-position'].includes('bottom') &&
      css`
        top: 2rem;
      `}

      ${(props) =>
      props['data-pr-position'] &&
      props['data-pr-position'].includes('left') &&
      css`
        transform: translate(-100%, 0);
      `}
      
      ${(props) =>
      props['data-pr-position'] &&
      props['data-pr-position'].includes('right') &&
      css`
        transform: translate(1rem, 0);
      `}
      
      white-space: break-spaces;
    padding: 0.5rem;
    ${(props) => props.theme.fonts.textSmall};
    text-transform: initial;
    background: #5b5b5b;
    display: none;
    width: max-content;
    max-width: 15rem;
  }
  & .tooltip-trigger:hover + .tooltip-content::before {
    display: initial;
    z-index: 1;
  }
`;

const Image = styled.img`
  height: 1rem;
  vertical-align: top;
  margin: 0;
  cursor: pointer;
  &:hover {
    & + * {
      display: initial;
    }
  }
`;

export default HelpIcon;
